import React from 'react';
import { motion } from 'framer-motion';
export const WhatIsSection = () => {
  return <section className="py-24 bg-soft/30" data-id="element-153">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-155">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-8 leading-tight" data-id="element-156">
            ¿Qué es La Conexión Cuántica?
          </h2>
          <p className="text-xl md:text-2xl text-primary/80 leading-relaxed max-w-3xl mx-auto" data-id="element-157">
            La Conexión Cuántica es un espacio de transformación integral donde
            aplicamos el Método INTEGRA®. Somos el puente entre tu estado
            actual y tus objetivos, utilizando esta metodología como la
            herramienta principal para reprogramar el subconsciente de manera
            segura y dirigida.
          </p>
        </motion.div>
      </div>
    </section>;
};